import React, { useCallback, useEffect, useState } from 'react';
import { Box, Card, Grid } from '@mui/material';
import { DialogForm, ICardActions, ICardColumns, IDialogActions, ISnackbarAlert, SnackbarAlert } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ApplicationFilterDTO, FeatureFilterDTO, Result, TestScenarioDTO } from '../../../shared/interfaces';
import { GenericCardList } from '../../share/generic-cruds/GenericCardList';
import { TestComponentFilterDTO } from '../../../shared/interfaces/testingSphere/TestComponentFilterDTO';
import { TestComponentDTO } from '../../../shared/interfaces/testingSphere/TestComponentDTO';
import { ListId, LocalStorange } from '../../../shared/environment';
import { useTheme } from '@mui/material/styles';
import { Feature } from '../../appSphere/feature/Feature';

interface ITestComponentSequenceProps {
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const TestComponentSequence: React.FC<ITestComponentSequenceProps> = ({ parentId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {
    const [testComponentDTO, setTestComponentDTO] = useState<TestComponentDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);
    const theme = useTheme();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    const [expadedData, setExpandedData] = useState<any>();

    useEffect(() => {
        setTestComponentDTO({
            ...testComponentDTO,
            name: '',
            orderExecution: 0,
            executionStatusId: '',
            createdById: ''
        } as TestComponentDTO);
    }, []);

    const handleAddSequenceTestComponentAsync = useCallback ( async (data: any) => {
        const dto: TestComponentDTO = {
            name: data.name,
            orderExecution: 0,
            executionStatusId: ListId.testingsphere.testpackage.executionstatusstart,
            featureId: data.id,
            testScenarioId: parentId || '',
            description: 'Associated feature ' + data.name,
            createdById: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('testingsphere.testcomponent', 'AddSequenceTestComponentAsync', dto, setActionExecuted, setLoading, showMessage);
    },[]);

    const handleDeleteClick = useCallback ( async (data: any) => {
        GenericService.DeleteAsync1('testingsphere.testcomponent', data.id, setLoading, setTestComponentDTO, showMessage);
    },[]);

    const handleAssociateClick = (data: string) => {
        handleAddSequenceTestComponentAsync(data);
    };

    const handleDisassociateClick = (data: string) => {
        handleDeleteClick(data);
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const filterAvailable: ApplicationFilterDTO = {
        name: '',
        typeId: '',
        companyId: ''
    };

    const localExpadedData = expadedData ?? '';

    const filterAvailableChildren: FeatureFilterDTO = {
        name: '',
        applicationId: localExpadedData.id,
    };

    const columnsAvailable: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 9, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'type', label: 'Type', size: 3, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
    ];

    const childrensColumnsAvailable: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 9, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'pathUrl', label: 'Path', size: 3, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
    ];

    const cardActionsAvailable: ICardActions[] = [
        { id: 'add', toolTip: 'Add', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleAssociateClick },
    ];

    const filterSelected: TestComponentFilterDTO = {
        name: '',
        testScenarioId: parentId,
    };

    const columnsSelected: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 8, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'orderExecution', label: 'Order', size: 1, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'feature', label: 'Feature', size: 3, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
    ];

    const cardActionsSelected: ICardActions[] = [
        { id: 'delete', toolTip: 'Delete', icon: 'delete_outlined', iconColor: 'error', setAction: handleDisassociateClick },
    ];

    const actions: IDialogActions[] = [
        { id: 'close', text: 'Close', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='TESTCOMPONENT SEQUENCE'
                icon='compare_arrows_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={false}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ bgcolor: theme.palette.background.default, p: 1, height: '53.5vh' }}>
                                <GenericCardList
                                    cardActions={cardActionsSelected}
                                    cardColumns={columnsSelected}
                                    entity={'testingsphere.testComponent'}
                                    filter={filterSelected}
                                    loading1={loading}
                                    hasChildren={false}
                                    setExpandedData={() => void undefined}
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ bgcolor: theme.palette.background.default, p: 1, height: '53.5vh' }}>
                                <GenericCardList
                                    cardActions={[]}
                                    cardColumns={columnsAvailable}
                                    entity={'appsphere.application'}
                                    filter={filterAvailable}
                                    loading1={false}
                                    hasChildren={true}
                                    childrenTitle={'FEATURE'}
                                    setExpandedData={setExpandedData}
                                    childrenComponent={(
                                        <Box width={'100%'}>
                                            <GenericCardList
                                                cardActions={cardActionsAvailable}
                                                cardColumns={childrensColumnsAvailable}
                                                entity={'appsphere.feature'}
                                                filter={filterAvailableChildren}
                                                loading1={false}
                                                hasChildren={false}
                                                setExpandedData={() => void undefined}
                                            />
                                        </Box>
                                    )}
                                />
                            </Card>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </DialogForm >
        </React.Fragment >
    );
};